import OrderManagerDetailEdit from "./OrderManager/OrderManagerDetailEdit";
import OrderManagerCreate from "./OrderManager/OrderManagerCreate";
import OrderManagerShipmentEdit from "./OrderManager/OrderManagerShipmentEdit";
import OrderManagerView from "./OrderManager/OrderManagerView";

export default class ClassRouter
{
    static pages = {
        "/bitrix/admin/sale_order_edit.php": OrderManagerDetailEdit,
        "/bitrix/admin/sale_order_shipment_edit.php": OrderManagerShipmentEdit,
        "/bitrix/admin/sale_order_create.php": OrderManagerCreate,
        "/bitrix/admin/sale_order_view.php": OrderManagerView,
    }

    static init(path)
    {
        if(this.pages[path]) {
            return new this.pages[path](this._getParamsAll());
        }
    }

    static _getParams(key) {
        let p = window.location.search;
        p = p.match(new RegExp(key + '=([^&=]+)'));
        return p ? p[1] : false;
    }

    static _getParamsAll()
    {
        let a = window.location.search;
        let b = new Object();
        a = a.substring(1).split("&");
        for (let i = 0; i < a.length; i++) {
            let c = a[i].split("=");
            b[c[0]] = c[1];
        }
        return b;
    }
}